module.exports = "https://web-assets.ifttt.com/packs/media/shared/404_unicorn-f58af7c3.svg";